import { canAccess } from '@/acl/roles';

const getMenuItemsList = (currentLocale = 'en') => [
  {
    url: '/dashboard',
    name: 'Dashboard',
    slug: 'dashboard',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'home',
    class: '',
  },
  {
    url: '/underwriting-tools',
    name: 'UnderwritingTools',
    slug: 'underwriting_tools',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'file-alt',
    class: '',
  },
  {
    url: '/notify-a-claim',
    name: 'ClaimNotificationForms',
    slug: 'notify_a_claim',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'exclamation-triangle',
    class: '',
  },
  {
    url: '/commissions',
    name: 'Commissions',
    slug: 'commissions',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'euro-sign',
    class: '',
  },
  {
    url: '/portfolio',
    name: 'Portfolio',
    slug: 'portfolio',
    i18n: 'Portfolio',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'briefcase',
    class: '',
  },
  {
    url: '/renewal',
    name: 'Renewals',
    slug: 'renewal',
    tagColor: 'warning',
    iconType: 'far',
    icon: 'pen-square',
    class: '',
  },
  {
    url: '/work-in-progress',
    name: 'WorkInProgress',
    slug: 'work_in_progress',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'tasks',
    class: '',
  },
  {
    name: 'Coverholder',
    iconType: 'fal',
    icon: 'briefcase',
    submenu: [
      {
        url: '/coverholder/portfolio',
        name: 'Portfolio',
        slug: 'coverholder_portfolio',
        i18n: 'Portfolio',
        tagColor: 'warning',
        iconType: 'fal',
        icon: 'briefcase',
        class: '',
      },
      {
        url: '/coverholder/work-in-progress',
        name: 'WorkInProgress',
        slug: 'coverholder_work_in_progress',
        i18n: 'WorkInProgress',
        tagColor: 'warning',
        iconType: 'fal',
        icon: 'tasks',
        class: '',
      },
    ]
  },
  {
    url: 'https://homepage.fides.international/contact-list/?company=fuw',
    name: 'Contacts',
    slug: 'external',
    i18n: 'Contacts',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'users',
    class: '',
    target: '_blank'
  },
  {
    url: '/upload',
    name: 'UploadFirmOrders',
    slug: 'upload_firm_orders',
    i18n: 'UploadFirmOrders',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-up',
    class: 'UploadFirmOrders',
  },
  {
    url: `${process.env.VUE_APP_LANDING_PAGE_URL}?lang=${currentLocale || 'en'}`,
    name: 'ReturnToFIDES',
    slug: 'external',
    i18n: 'ReturnToFIDES',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-left',
    class: 'return-to-fides mb-4',
  },
];

const canAccessMenuItem = (item) => {
  return canAccess(item);
}

// export const getMenuItems = async () => {
//   const filteredMenuItems = [];

//   for (const menuItem of menuItems) {
//     if (await canAccessMenuItem(menuItem)) {
//       filteredMenuItems.push(menuItem);
//     }
//   }

//   return filteredMenuItems;
// };

export const getMenuItems = (currentLocale = 'en') => {
  const menuItems = getMenuItemsList(currentLocale);
  const filteredMenuItems = [];

  for (const menuItem of menuItems) {
    if (menuItem.submenu) {
      const subMenu = menuItem.submenu;
      menuItem.submenu = subMenu.filter((submenuItem) => {
        if (submenuItem.submenu) {
          const childSubMenu = submenuItem.submenu;
          submenuItem.submenu = childSubMenu.filter((childSubmenuItem) => {
            if (childSubmenuItem.slug) {
              return canAccessMenuItem(childSubmenuItem);
            }
          });
        }

        if (submenuItem.slug) {
          return canAccessMenuItem(submenuItem);
        }

        return true;
      });

      if (menuItem.submenu.length > 0) {
        filteredMenuItems.push(menuItem);
      }
    } else if (canAccessMenuItem(menuItem)) {
      filteredMenuItems.push(menuItem);
    }
  }

  return filteredMenuItems;
};
